var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item-date",class:{ range: _vm.isDateRange }},[_c('el-date-picker',_vm._g(_vm._b({staticStyle:{"width":"100%"},on:{"change":_vm.transformDate}},'el-date-picker',{
      startPlaceholder: _vm.$MGUI.i18n.t('开始日期'),
      endPlaceholder: _vm.$MGUI.i18n.t('结束日期'),
      valueFormat: 'timestamp',
      ..._vm.$attrs,
    },false),_vm.$listeners)),(_vm.isDateRange)?_c('div',{staticClass:"shortcut-date"},[_vm._l((_vm.shortcutDateList),function(date){return [_c('span',{key:date.value,on:{"click":function($event){return _vm.handleShortcutDate(date)}}},[_vm._v(_vm._s(date.label))])]})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }